import {
  COST_CHANGE_INSIGHTS_DEFAULT_SELECTIONS,
  COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP,
  COST_CHANGE_INSIGHTS_LOCATION_OPTIONS,
} from '../../globalConfig/constants'
import uniq from 'lodash/uniq'
import isEqual from 'lodash/isEqual'

export const reducer = (state, action) => {
  switch (action.type) {
    case 'set_default_selections': {
      return {
        ...state,
        [action.pathname]: {
          searchCriteria: action.value,
        },
      }
    }

    case 'update_criteria_for_multiple_fields': {
      const concatenatedArrays = {}
      Object.keys(action.value).forEach((selectionKey) => {
        concatenatedArrays[selectionKey] = Array.isArray(
          state?.[action.pathname].searchCriteria[selectionKey],
        )
          ? uniq(
              state?.[action.pathname].searchCriteria[selectionKey].concat(
                action.value[selectionKey],
              ),
              false,
            )
          : action.value[selectionKey]
      })
      return {
        ...state,
        [action.pathname]: {
          searchCriteria: {
            ...state?.[action.pathname].searchCriteria,
            ...concatenatedArrays,
          },
        },
      }
    }

    case 'update_criteria_by_field': {
      if (
        action?.field?.variableName &&
        !isEqual(
          state?.[action.pathname]?.searchCriteria[action.field.variableName],
          action.value,
        )
      ) {
        return {
          ...state,
          [action.pathname]: {
            searchCriteria: {
              ...state?.[action.pathname]?.searchCriteria,
              [action.field.variableName]: action.value,
            },
          },
        }
      } else {
        return state
      }
    }

    case 'update_cost_location_group_values': {
      const value = Array.isArray(action.value) ? action.value : [action.value]
      return {
        ...state,
        [action.pathname]: {
          searchCriteria: {
            ...state?.[action.pathname].searchCriteria,
            [COST_CHANGE_INSIGHTS_LOCATION_OPTIONS.COST_LOCATION_GROUP_VALUES
              .variableName]: value.map((obj) => obj.value),
          },
        },
      }
    }

    case 'update_cost_location_group_type': {
      return {
        ...state,
        [action.pathname]: {
          searchCriteria: {
            ...state?.[action.pathname].searchCriteria,
            [COST_CHANGE_INSIGHTS_LOCATION_OPTIONS?.COST_LOCATION_GROUP_TYPE
              ?.variableName]: action.value,
          },
        },
      }
    }

    case 'reset_criteria_to_default': {
      return {
        ...state,
        [action.pathname]: {
          searchCriteria:
            COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP?.[
              action.pathname
            ]?.GET_DEFAULT_SELECTIONS() ||
            COST_CHANGE_INSIGHTS_DEFAULT_SELECTIONS,
        },
      }
    }

    case 'initiate_search': {
      return {
        ...state,
        initiateSearch: true,
      }
    }

    case 'reset_initiate_search': {
      return {
        ...state,
        initiateSearch: false,
      }
    }

    default:
      return state
  }
}

export const initialState = Object.keys(
  COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP,
).reduce((acc, key) => {
  acc[key] = {
    searchCriteria:
      key === '/insights'
        ? COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP[key].GET_DEFAULT_SELECTIONS()
        : null,
  }
  return acc
}, {})
